import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(seo)/seo-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/navigation/navigation-actions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/navigation/navigation-desktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/navigation/navigation-mobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/navigation/navigation-scroll-top.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
